import { signalStore, withProps } from '@ngrx/signals';
import {
  withEntitiesLocalFilter,
  withEntitiesLocalSort,
  withEntitiesLocalPagination,
  withLogger,
} from '@ngrx-traits/signals';
import { inject } from '@angular/core';
import { ImpersonationUser } from '../models/impersonation-user.model';
import { ImpersonationService } from '../data/impersonation.service';
import { withEntities } from '@ngrx/signals/entities';
import { withCallStatus, withEntitiesLoadingCall } from '@ngrx-traits/signals';

const entity = {} as ImpersonationUser;
const collection = 'impersonationUsers';

interface ImpersonationUserFilter {
  search: string;
}

export const ImpersonationUsersStore = signalStore(
  withEntities({ entity, collection }),
  withCallStatus({ collection, initialValue: 'init' }),
  withLogger({
    name: 'ImpersonationUsersStore',
    showDiff: true,
  }),
  withProps(() => ({
    impersonationService: inject(ImpersonationService),
  })),
  withEntitiesLoadingCall({
    collection,
    fetchEntities: ({ impersonationService }) =>
      impersonationService.getImpersonationUsers(),
  }),
  withEntitiesLocalFilter(
    { entity, collection },
    {
      defaultFilter: { search: '' },
      filterFn: (user: ImpersonationUser, filter: ImpersonationUserFilter) => {
        if (!filter?.search) return true;
        const search = filter.search.toLowerCase();
        return (
          user.displayName.toLowerCase().includes(search) ||
          user.email.toLowerCase().includes(search) ||
          user.firstName.toLowerCase().includes(search) ||
          user.lastName.toLowerCase().includes(search) ||
          user.tenant?.name?.toLowerCase().includes(search)
        );
      },
    }
  ),
  withEntitiesLocalSort(
    { entity, collection },
    {
      defaultSort: { field: 'displayName', direction: 'asc' },
    }
  ),
  withEntitiesLocalPagination(
    { entity, collection },
    {
      pageSize: 20,
    }
  )
);
